// In-memory cache for loaded recommendations (keyed by report ID).
// Used by recommendation UI tabs so results persist across tab switches.

const loadedRecommendationsStorage = new Map();

export function storeDosRecommendations(reportId, recommendations) {
    if (reportId && recommendations) {
        loadedRecommendationsStorage.set(`dos_${reportId}`, recommendations);
    }
}

export function getStoredDosRecommendations(reportId) {
    return loadedRecommendationsStorage.get(`dos_${reportId}`) || null;
}

export function storeMcpRecommendations(reportId, recommendations) {
    if (reportId && recommendations) {
        loadedRecommendationsStorage.set(`mcp_${reportId}`, recommendations);
    }
}

export function getStoredMcpRecommendations(reportId) {
    return loadedRecommendationsStorage.get(`mcp_${reportId}`) || null;
}

export function storeFullTesterRecommendations(reportId, recommendations) {
    if (reportId && recommendations) {
        loadedRecommendationsStorage.set(`full_${reportId}`, recommendations);
    }
}

export function getStoredFullTesterRecommendations(reportId) {
    return loadedRecommendationsStorage.get(`full_${reportId}`) || null;
}

export function storeRtoRecommendations(reportId, recommendations) {
    if (reportId && recommendations) {
        loadedRecommendationsStorage.set(`rto_${reportId}`, recommendations);
    }
}

export function getStoredRtoRecommendations(reportId) {
    return loadedRecommendationsStorage.get(`rto_${reportId}`) || null;
}

export function storeRcRecommendations(reportId, recommendations) {
    if (reportId && recommendations) {
        loadedRecommendationsStorage.set(`rc_${reportId}`, recommendations);
    }
}

export function getStoredRcRecommendations(reportId) {
    return loadedRecommendationsStorage.get(`rc_${reportId}`) || null;
}

export function storeLlmRecommendations(reportId, recommendations) {
    if (reportId && recommendations) {
        loadedRecommendationsStorage.set(`llm_${reportId}`, recommendations);
    }
}

export function getStoredLlmRecommendations(reportId) {
    return loadedRecommendationsStorage.get(`llm_${reportId}`) || null;
}
